import isEqual from 'fast-deep-equal';
import { devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createWithEqualityFn } from 'zustand/traditional';

import { ISidebarState } from 'types/store/sidebar';

export const useSidebarStore = createWithEqualityFn<ISidebarState>()(
  persist(
    immer(
      devtools((set, _get) => ({
        open: false,
        setOpen: (value: boolean) =>
          set(() => ({ open: value }), false, {
            type: 'side-bar/setOpen',
          }),
      }))
    ),
    {
      name: 'side-bar',
      version: 1,
    }
  ),
  isEqual
);
